var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product" }, [
    _c("h2", [_vm._v("商品信息")]),
    _vm._v(" "),
    _c("div", { staticClass: "normal" }, [
      _vm._v("商品标题：\n    "),
      _c(
        "div",
        { staticClass: "inputBox" },
        [
          _c("el-input", {
            model: {
              value: _vm.title,
              callback: function($$v) {
                _vm.title = $$v
              },
              expression: "title"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "normal" },
      [
        _vm._v("所属店铺：\n    "),
        _c(
          "el-select",
          {
            attrs: {
              filterable: "",
              placeholder: "选择店铺",
              "default-first-option": "",
              "remote-method": _vm.searchShop,
              remote: "",
              clearable: ""
            },
            model: {
              value: _vm.shop_id,
              callback: function($$v) {
                _vm.shop_id = $$v
              },
              expression: "shop_id"
            }
          },
          _vm._l(_vm.matchShops, function(item) {
            return _c("el-option", {
              key: item.id,
              attrs: { label: item.name, value: item.id }
            })
          }),
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "normal" }, [
      _vm._v("优惠券金额：\n    "),
      _c(
        "div",
        { staticClass: "inputBox" },
        [
          _c("el-input", {
            attrs: { type: "number" },
            model: {
              value: _vm.coupon_val,
              callback: function($$v) {
                _vm.coupon_val = $$v
              },
              expression: "coupon_val"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "normal" },
      [
        _vm._v("一级类目：\n    "),
        _c(
          "el-select",
          {
            attrs: {
              filterable: "",
              placeholder: "选择类目",
              "default-first-option": ""
            },
            model: {
              value: _vm.cat_name,
              callback: function($$v) {
                _vm.cat_name = $$v
              },
              expression: "cat_name"
            }
          },
          _vm._l(_vm.catNames, function(item) {
            return _c("el-option", {
              key: item,
              attrs: { label: item, value: item }
            })
          }),
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "line" }, [
      _vm._v("----------------封面图----------------")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "normal" }, [
      _c("input", {
        attrs: { type: "file", id: "cover_image" },
        on: { change: _vm.chooseImage }
      })
    ]),
    _vm._v(" "),
    _vm.cover_image
      ? _c("div", { staticClass: "imageBoxMini" }, [
          _c("img", {
            attrs: {
              src: _vm.cover_image,
              preview: "3",
              "preview-text": "封面图"
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "line" }, [
      _vm._v("----------------详情头图----------------")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "normal" }, [
      _c("input", {
        attrs: { type: "file", id: "top_images" },
        on: { change: _vm.chooseImage }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticStyle: { display: "inline-block" } }, [
      _c(
        "div",
        { staticClass: "imageBox" },
        _vm._l(_vm.top_images, function(url, index) {
          return _c("div", { key: index, staticClass: "imageItem" }, [
            _c("div", [
              _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.toBeFirst(index)
                    }
                  }
                },
                [_vm._v("置顶")]
              )
            ]),
            _vm._v(" "),
            _c("img", {
              attrs: { src: url, preview: "6", "preview-text": "头图" }
            }),
            _vm._v(" "),
            _c("div", [
              _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.delTopImage(index)
                    }
                  }
                },
                [_vm._v("删除")]
              )
            ])
          ])
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.upToDb } },
          [_vm._v("上传")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-360b7628", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-360b7628","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/Product.vue
// module id = null
// module chunks = 